<mat-tab-group animationDuration="0ms" [selectedIndex]="1">
  <mat-tab label="{{ 'page.steps.title' | translate }}">
    <div class="px-3 pt-3 pb-3">
      <app-steps></app-steps>
    </div>
  </mat-tab>
  <mat-tab label="{{ 'page.workflows.title' | translate }}">
    <div class="px-3 pt-3 pb-3">
      <app-workflows></app-workflows>
    </div>
  </mat-tab>
</mat-tab-group>
